<template>
  <v-form ref="form" @submit.prevent="onSubmit">
    <v-card-text class="pt-5">
      <v-row class="ma-0">
        <div class="d-flex flex-column" v-if="!readonly || group.picture">
          <image-input
            class="mx-auto"
            :value="group.picture"
            :readonly="readonly"
            @change="onLogoChange"
          ></image-input>
          <p class="text-center" style="color: #333333bd">Group Logo</p>
        </div>
        <v-col class="ms-4">
          <label style="color: #333333bd">
            Group Name
            <v-text-field
              outlined
              placeholder="Enter Group Name"
              name="name"
              v-model="group.name"
              :rules="[rules.required]"
              hide-details="auto"
              :readonly="readonly"
              autocomplete="off"
            />
          </label>
        </v-col>
      </v-row>

      <label style="color: #333333bd">
        <v-textarea
          class="mt-2"
          outlined
          placeholder="Enter Group Description"
          name="disclaimer"
          v-model="group.disclaimer"
          hide-details="auto"
          :readonly="readonly"
          autocomplete="off"
          rows="3"
        />
      </label>
    </v-card-text>

    <v-divider class="mt-4"></v-divider>

    <v-card-text>
      <h3>Participants</h3>
      <v-row class="ma-0 my-2" v-if="!readonly">
        <v-col cols="8">
          <v-text-field
            outlined
            dense
            hide-details
            placeholder="Search.."
            prepend-inner-icon="mdi-magnify"
            v-model="searchQuery"
          />
        </v-col>
        <v-col cols="4" align="center" align-self="center">
          <v-row class="ma-0" align="center" justify="end">
            <span> Select All </span>
            <v-checkbox
              class="mt-n2"
              @change="onSelectAllChange"
              hide-details="auto"
              :readonly="readonly"
            />
          </v-row>
        </v-col>
      </v-row>

      <v-progress-circular
        v-if="usersLoading"
        class="mx-auto"
        indeterminate
      ></v-progress-circular>

      <!-- <div v-if="!usersLoading && !readonly">
        <v-checkbox
          label="Select All"
          @change="onSelectAllChange"
          hide-details="auto"
          :readonly="readonly"
        ></v-checkbox>
      </div> -->
    </v-card-text>

    <group-modal-followers-list
      :selectAll="selectAllParticipants"
      :isEditing="isEditing"
      :readonly="readonly"
      v-model="participants"
    ></group-modal-followers-list>

    <v-card-actions v-if="!readonly" class="px-4">
      <v-spacer></v-spacer>
      <v-btn
        v-if="isEditing"
        class="text-none font-weight-bold py-5 px-6"
        dark
        color="#2D8CFF"
        elevation="0"
        type="submit"
        :loading="loading"
      >
        Save
      </v-btn>
      <v-btn
        v-else
        class="text-none font-weight-bold py-5 px-6"
        dark
        color="#2D8CFF"
        elevation="0"
        type="submit"
        :loading="loading"
      >
        Create Group
      </v-btn>
    </v-card-actions>
  </v-form>
</template>

<script>
import GroupModalFollowersList from "./GroupModalFollowersList.vue";
import ImageInput from "./ImageInput.vue";

export default {
  components: { ImageInput, GroupModalFollowersList },

  data() {
    return {
      rules: { required: (v) => !!v || "This field is required." },
      group: { ...this.value },
      logo: null,
      selectAllParticipants: false,
      usersLoading: false,
      participants: [],
    };
  },

  props: {
    loading: {
      type: Boolean,
    },

    value: {
      type: Object,
      default: () => ({
        id: null,
        name: "",
        disclaimer: "",
        logo: undefined,
        picture: null,
      }),
    },

    readonly: {
      type: Boolean,
    },
  },

  async created() {
    this.usersLoading = true;

    try {
      if (this.readonly) {
        await this.$store.dispatch("groups/fetchGroupParticipants");
      } else if (this.isEditing) {
        await this.$store.dispatch("groups/fetchGroupUsers");
        this.participants = this.users
          .filter((u) => u.is_participant)
          .map((u) => u.id);
      } else {
        await this.$store.dispatch("Auth/fetchFollowers");
      }
    } finally {
      this.usersLoading = false;
    }
  },

  computed: {
    users() {
      if (this.readonly) return this.$store.state.groups.groupParticipants;
      if (this.isEditing) return this.$store.state.groups.groupUsers;
      return this.$store.state.Auth.followers;
    },

    isEditing() {
      return this.value.id !== null && !this.readonly;
    },

    searchQuery: {
      get() {
        if (this.isEditing) {
          return this.$store.state.groups.groupUsersMeta.search_query;
        } else {
          return this.$store.state.Auth.followersMeta.search_query;
        }
      },

      set(val) {
        if (this.isEditing) {
          this.$store.commit("groups/setGroupUsersMetaSearchQuery", val);
        } else {
          this.$store.commit("Auth/setFollowersMetaSearchQuery", val);
        }
        // this.fetch();
      },
    },
  },

  methods: {
    onLogoChange(file) {
      this.group.logo = file;
    },

    onSelectAllChange(value) {
      this.participants = [];
      this.selectAllParticipants = value;
    },

    onSubmit() {
      if (!this.$refs.form.validate()) return;
      this.$emit("submit", {
        ...this.group,
        participants: this.participants,
        addAll: this.selectAllParticipants,
      });
    },
  },
};
</script>
